// extracted by mini-css-extract-plugin
export default {"header":"style_header__ir88q","title":"style_title__hzkcg"};